import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=c899e310&scoped=true"
import script from "./shopDetail.vue?vue&type=script&lang=ts"
export * from "./shopDetail.vue?vue&type=script&lang=ts"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=c899e310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c899e310",
  null
  
)

export default component.exports